/* eslint-disable @next/next/no-img-element, react/forbid-component-props */
import classNames from 'classnames';
import Link from 'next/link';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { VIP_INFO_MODAL } from '../../brands/default/content/components/checkout';
import { LINK_VIP_TERMS } from '../../brands/default/links';
import {
  VIP_BG,
  VIP_INFO_BULLET,
  VIP_LOGO,
} from '../../config/constants/images';
import { getCountryCurrency } from '../../helpers/currency';
import ThemeContext from '../../providers/ThemeProvider';
import WowModal from '../WowModal';
import PrimaryButton from '../_generic/button/PrimaryButton';

export default function VipInfoModal({
  handleQuickBuy,
  onClose,
  show,
  secondCheckout,
}) {
  const theme = useContext(ThemeContext);
  const BULLET_LIST = VIP_INFO_MODAL.bulletPoints;

  return (
    <>
      <WowModal
        ariaLabelledBy="id-vip-modal"
        extraClasses="vip-modal"
        setShowModal={onClose}
        showHeader
        showModal={show}
      >
        <img alt={'Logo'} className="vip-modal__logo" src={VIP_LOGO} />
        <h3 className="vip-modal__title">{VIP_INFO_MODAL.infoTitle}</h3>
        <ul className="vip-modal__list">
          {BULLET_LIST.map((bullet, index) => (
            <li
              className="vip-modal__list-item"
              key={String(`vip-bullet-${index}`)}
            >
              {!secondCheckout && (
                <img alt="" height={15} src={VIP_INFO_BULLET} width={15} />
              )}
              <span>
                {bullet.replace('##currency##', getCountryCurrency())}
              </span>
            </li>
          ))}
        </ul>
        <p>{VIP_INFO_MODAL.infoText}</p>
        <p className={classNames({ 'vip-modal_terms': secondCheckout })}>
          {VIP_INFO_MODAL.tnc}{' '}
          <Link href={LINK_VIP_TERMS ?? ''}>
            <a
              className={classNames({ 'vip-modal_anchor': secondCheckout })}
              rel="noreferrer"
              target="_blank"
            >
              here
            </a>
          </Link>
        </p>

        {secondCheckout && (
          <PrimaryButton
            aria-label={VIP_INFO_MODAL.quickBuy}
            className="vip-modal__quick-buy size-large"
            id="quick-buy"
            onClick={handleQuickBuy}
          >
            {VIP_INFO_MODAL.quickBuy}
          </PrimaryButton>
        )}
      </WowModal>

      <style jsx>{`
        .vip-modal__logo {
          padding: 2rem;
          width: 16rem;
        }
        .vip-modal__title {
          margin-bottom: 16px;
        }
        .vip-modal__list {
          padding: 0 0 16px 16px;
          font-size: 16px;
          display: flex;
          flex-flow: column;≠
          align-items: center;
          list-style-type: ${secondCheckout ? `disc` : `none`};
        }
        .vip-modal__list-item {
          display: ${secondCheckout ? `list-item` : `flex`};
          justify-content: space-around;
          line-height: 25px;
          gap: 0.8rem;
        }
        .vip-modal__list-item img {
          margin-top: 4px;
        }
        .vip-modal_terms{
          font-size: 12px;
        }
        .vip-modal_anchor{
          text-decoration: underline;
          color: ${theme.colors.white};
        }
        :global(.vip-modal__quick-buy) {
          width: 75%;
          font-weight: 500;
          padding: 10px 0;
          margin: 16px auto 0;
        }
        :global(.vip-modal .modal-header) {
          width: 100%;
          position: absolute;
        }
        :global(.vip-modal .close) {
          opacity: 1;
          position: absolute;
          z-index: 1;
          top: 3rem;
          right: 3rem;
          color: ${theme.colors.white};
        }
        :global(.vip-modal .modal-body) {
          padding: 0 20px 20px 20px;
          margin: 15px;
          font-size: 16px;
          text-align: center;
          border: ${
            secondCheckout ? `none` : `2px solid ${theme.colors.white}`
          };
        }
        :global(.vip-modal .modal-content) {
          background: url(${VIP_BG}), ${theme.commoncolors.black};
          background-size: cover;
          color: ${theme.colors.white};
          border-radius: ${secondCheckout ? `44px` : `0px`};
        }
        :global(.vip-modal .modal-content:before) {
          content: '';
          position: absolute;
          margin: 10px;
          width: calc(100% - 20px);
          height: calc(100% - 20px);
          border: ${secondCheckout ? `1px` : `2px`} solid ${theme.colors.white};
          border-radius: ${secondCheckout ? `44px` : `0px`};

        }
      `}</style>
    </>
  );
}

VipInfoModal.propTypes = {
  handleQuickBuy: PropTypes.func,
  onClose: PropTypes.func,
  secondCheckout: PropTypes.bool,
  show: PropTypes.bool,
};
